export const getUrlForDynamicEnv = data => {
  const split = window.location.hostname.split('.');
  const childSubdomain = split[0];
  const parentSubdomain = split[1];
  const isIncentivioDashboardUrl = parentSubdomain === 'dashboard';
  let url = window.location.href;

  if (isIncentivioDashboardUrl)
    url = window.location.href.replace(
      childSubdomain,
      data.REACT_APP_DEFAULT_CLIENT,
    );

  const urlObj = new URL(url);
  urlObj.searchParams.set('envData', JSON.stringify(data));
  return urlObj.toString();
};
